<template>
<div id="bottom">
    <div class="cc-header">
        <!--<dv-decoration-7 :color="['#f00', '#f00']" style="width: 5rem;height: 0.5rem;"><div style="margin: 0 0.1rem;"> 高温预警月趋势 </div></dv-decoration-7>-->
        高温预警月趋势
    </div>
    <div class="d-flex jc-center">
        <div id="lineChart" class="lineChart"></div>
    </div>
</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
    data() {
        return {};
    },
    mounted() {
        this.initData();
        // 定时器刷新，30分钟
        let _this = this;
        setInterval(() => {
            _this.initData(); // 修改数据date
        }, 1000 * 60 * 30);
    },
    methods: {
        initData() {
            // 基于准备好的dom，初始化echarts实例
            let myChartPieLeft = echarts.init(
                document.getElementById("lineChart")
            );
            this.$http.get("/dataView/temp/getCountGroupByDay?orgCode=" + orgCode).then(res => {
                if (res.data.code === 200) {
                    var legends = res.data.result.legends;
                    var xAxisData = res.data.result.xData;
                    var yData = res.data.result.yData;
                    var yAxisData = [];
                    var colors = ["#8BC34A", "#F44336", "#FFEB3B", "#00BCD4", "#03A9F4", "#FF9800", "#c6d629", "#795548", "#e0306c", "#a70fc1"];
                    for (var i = 0; i < yData.length; i++) {
                        if (i > 9) {
                            yAxisData.push({
                                name: yData[i].name,
                                type: 'line',
                                smooth: true,
                                data: yData[i].data
                            });
                        } else {
                            yAxisData.push({
                                name: yData[i].name,
                                type: 'line',
                                smooth: true,
                                data: yData[i].data,
                                itemStyle: {
                                    normal: {
                                        color: colors[i], //折线点的颜色
                                        lineStyle: {
                                            color: colors[i] //折线的颜色
                                        }
                                    }
                                }
                            });
                        }
                    }

                    var option = {
                        tooltip: {
                            trigger: 'axis'
                        },
						
                        legend: {
							show: false,
                            orient: 'vertical',
                            x: 'left', //可设定图例在左、右、居中
                            y: 'top', //可设定图例在上、下、居中
							padding: [0, 0, 6, 0], //可设定图例[距上方距离，距右方距离，距下方距离，距左方距离]
                            data: legends,
                            textStyle: {
                                color: '#fff'
                            },
                            formatter: function (params) {
                                if (!params) return '';
                                if (params.length > 5) {
                                    return params.slice(0, 5) + '...';
                                } else {
                                    return params;
                                }
                            },
                            tooltip: {
                                show: true
                            }
                        },
                        grid: {
                            left: '1%',
                            right: '1%',
                            top: '4%',
							bottom: '6%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: xAxisData,
                            axisLine: {
                                lineStyle: {
                                    color: '#fff'
                                }
                            },
                            axisLabel: {
                                interval: 0,
                                rotate: 60,
								textStyle: {
									fontSize: fontSize(0.15)
								}
							}
                        },
                        yAxis: {
                            type: 'value',
                            axisLine: {
                                lineStyle: {
                                    color: '#fff'
                                }
                            }
                        },
                        series: yAxisData
                    }
                }
                myChartPieLeft.hideLoading(); //没有加载出来隐藏加载动画
                myChartPieLeft.setOption(option);
                // 响应式变化
                window.addEventListener("resize", () => myChartPieLeft.resize(), false);
            });
        }
    },
    destroyed() {
        window.onresize = null;
    }
};
function fontSize(res){
    let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
    if (!clientWidth) return;
    let fontSize = 100 * (clientWidth / 1920);
    return res*fontSize;
}
</script>

<style lang="scss">
#bottom {
    //height: 25vh;

    .cc-header {
        height: 0.75rem;
        color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .lineChart {
        width: 22rem;
        height: 3.3rem;
    }
}
</style>
